import { stringOrUndefined } from "@faire/deprecated-retailer-visitor-shared/lib/stringOrUndefined";
import { IGetEmailPreferencesResponse } from "@faire/web-api--source/com/faire/email/preferences/IGetEmailPreferencesResponse";
import { QueryParameters } from "@faire/web-api--source/endpoints/www/api/email/preferences/get";
import {
  useQuery as useQueryPreferences,
  getQueryKey as getQueryPreferencesKey,
} from "@faire/web-api--source/endpoints/www/api/email/preferences/get-hooks";
import { useQueryClient } from "@tanstack/react-query";
import qs from "qs";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";

export const useEmailPreferencesQuery = () => {
  const location = useLocation();
  const outgoingEmail = stringOrUndefined(
    qs.parse(location.search).outgoing_email
  );
  const preferencesQueryParameters = QueryParameters.build({
    outgoing_email: outgoingEmail,
  });
  const queryClient = useQueryClient();

  const {
    data: emailPreferencesResponse,
    isLoading: isQueryPreferencesLoading,
    isError: isQueryPreferencesError,
  } = useQueryPreferences(preferencesQueryParameters, { staleTime: Infinity });

  const updateEmailPreferencesQuery = useCallback(
    (
      updateValueOrFn:
        | IGetEmailPreferencesResponse
        | ((
            current: IGetEmailPreferencesResponse
          ) => IGetEmailPreferencesResponse)
    ) => {
      queryClient.setQueryData(
        getQueryPreferencesKey(preferencesQueryParameters),
        updateValueOrFn
      );
    },
    [queryClient, preferencesQueryParameters]
  );

  return {
    emailPreferencesResponse,
    preferencesQueryParameters,
    isQueryPreferencesLoading,
    isQueryPreferencesError,
    updateEmailPreferencesQuery,
  };
};
